module.exports = __webpack_public_path__ + "img/ble_plus.a7b29dbd.png";